import React from 'react';
import PropTypes from 'prop-types';
import { trackElement } from '@nexus/fff-analytics';

import { EXPIRED, NOT_SUBSCRIBED, SKIPPED } from './boxStatusId';

const AddressDetails = ({
  isChallenge, shippingAddress, hasFailed, boxStatusId,
}) => (
  (boxStatusId === EXPIRED || boxStatusId === SKIPPED || boxStatusId === NOT_SUBSCRIBED)
    ? (
      <div className={isChallenge ? 'challenge-address-container' : 'address-container'} />
    )
    : (
      <div className={isChallenge ? 'challenge-address-container' : 'address-container'}>
        {!hasFailed && (
          <>
            <span className="address-title">SHIPPING ADDRESS</span>
            {shippingAddress && (
              <>
                <p className="address-details">{shippingAddress.userName}</p>
                <p className="address-piece">{shippingAddress.address1}</p>
                {shippingAddress.address2 && <p className="address-piece">{shippingAddress.address2}</p>}
                <p className="address-piece">
                  {`${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postalCode}`}
                </p>
              </>
            )}
            <a
              href="/my-account"
              onClick={() => trackElement('EDIT ADDRESS - BOX STATUS')}
              className="highlighted"
            >
              Edit
            </a>
          </>
        )}
      </div>
    )
);

AddressDetails.defaultProps = {
  isChallenge: false,
  shippingAddress: {
    userName: '',
    address1: '',
    city: '',
    state: '',
    postalCode: '',
  },
  hasFailed: false,
};

AddressDetails.propTypes = {
  isChallenge: PropTypes.bool,
  shippingAddress: PropTypes.shape({
    userName: PropTypes.string,
    address1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  hasFailed: PropTypes.bool,
};

export default AddressDetails;
